import { RequestStatus } from '../Constants';
export const getIsTeamsRequestSucceeded = state => state.teams.get('status') === RequestStatus.SUCCEEDED;
export const getPortalTeams = state => state.teams.get('teams');